import React, { FC, useState } from 'react'

import useEvent from 'Hooks/useEvent'
import X from 'Icons/x.svg'
import { Chat } from 'Types'

import LocationSelect from './LocationSelect'
import MessageForm from './MessageForm'
import Messages from './Messages'

enum SignUpState {
  INIT = -1,
  CLOSE = 0,
  OPEN = 1,
}

interface Props {
  chat?: Chat
  locationId: string
  onClose(e: unknown): void
  open: boolean
  setLocationId(locationId: string): void
}

const ChatBox: FC<Props> = ({ chat, locationId, setLocationId, open, onClose }) => {
  const [signUpState, setSignUpState] = useState(SignUpState.INIT)
  const openSignupForm = signUpState === SignUpState.OPEN

  const handleHide = useEvent(() => setSignUpState(SignUpState.CLOSE))
  const handleShow = useEvent(() => {
    if (signUpState === SignUpState.INIT) setSignUpState(SignUpState.OPEN)
  })

  return (
    <div className={`chatBox__dialog ${open ? 'is-active' : ''}`}>
      <div className="chatBox__dialog--header">
        <LocationSelect value={locationId} onChange={setLocationId} />

        <div className="chatBox__dialog--header-close" onClick={onClose}>
          <X />
        </div>
      </div>

      {chat ? (
        <Messages chat={chat} hideSignupForm={handleHide} open={open} openSignupForm={openSignupForm} />
      ) : (
        <div className="chatBox__dialog--body--wrap" />
      )}

      <MessageForm chatId={chat?.id} showSignupForm={handleShow} />
    </div>
  )
}

export default ChatBox
